<app-modal [title]="'Login'" [(visible)]="visible" [close]="false" [keyboard]="false">
    <div #modalContent ngProjectAs="modal-content">
        <div class="mb-4">
            <p class="font-light">Session has expired; re-Login to continue where you left off.</p>
        </div>
        <app-login-form (login)="hide()"/>
    </div>
</app-modal>